export class Setting {
  constructor() {

    /** @type {string|null} */
    this.name = null;

    /** @type {string|null} */
    this.value = null;

    /** @type {string|null} */
    this.updated_at = null;
  }

}
